import { OvertimeSettlementOutcome, ServiceWorkerContractEmploymentType } from '@navio/nsdk';

// Trim noisy precision for display (e.g. 12.333333 -> "12.33", 12 -> "12").
export const formatNumber = (value: number, maxDecimals = 2) => Number(value.toFixed(maxDecimals)).toString();

// Short labels for the compact "Approve method" badges (the canonical SDK
// labels are too long for a table cell). Overtime is the base rate plus a
// supplement (ADR 0007); TIME_OFF banks the base hours and pays out only the
// supplement.
export const overtimeOutcomeShortLabel: Record<OvertimeSettlementOutcome, string> = {
  [OvertimeSettlementOutcome.PAID_REGULAR]: 'Regular rate',
  [OvertimeSettlementOutcome.PAID_OVERTIME]: 'With supplement',
  [OvertimeSettlementOutcome.TIME_OFF]: 'Time off in lieu'
};

export const overtimeOutcomeBadgeVariant: Record<OvertimeSettlementOutcome, 'outline' | 'success' | 'warning'> = {
  [OvertimeSettlementOutcome.PAID_REGULAR]: 'outline',
  [OvertimeSettlementOutcome.PAID_OVERTIME]: 'success',
  [OvertimeSettlementOutcome.TIME_OFF]: 'warning'
};

// FREELANCE / SUBCONTRACTOR don't clock in for their own routes, so route
// overtime / overlap flags (ADR 0004) only apply to them.
export const isNonClockingRoute = (employmentType: ServiceWorkerContractEmploymentType | null | undefined): boolean =>
  employmentType === ServiceWorkerContractEmploymentType.FREELANCE ||
  employmentType === ServiceWorkerContractEmploymentType.SUBCONTRACTOR;
